import * as React from "react";
import { CardItem, ScheduleCardProps } from "../Schedule/Schedule";
import { useFetchMatchDetail } from "../../../../../networks";
import { Loading } from "../../../../../components";
import Show from "../../../FormRegistration/components/Show";
import MatchDetail from "../MatchDetail";
import TopStats from "../../../KlasemenPertandinganSoc/components/TopStats";
import useWindowSize from "../../../../../hooks/useWindowSize";
import { func } from "../../../../../utils";
import ScoreBoard from "../../../../JadwalPertandingan/components/ScoreBoard";

export interface StatisticDetailProps {
  data: ScheduleCardProps;
}

const StatisticDetail: React.FC<StatisticDetailProps> = ({ data }) => {
  const { size } = useWindowSize();
  // @ts-ignore
  const isMobileView = (size?.width || 0) <= 830;

  const [activeTab, setActiveTab] = React.useState<number>(0);

  const matchId = data?.id;

  const {
    data: dataMatchDetailRaw,
    isFetching,
    isRefetching,
  } = useFetchMatchDetail(matchId, !!matchId);

  // const {
  //   data: dataMatchesDetailRaw,
  //   isFetching,
  //   isRefetching,
  // } = useFetchLiveMatchesDetail(matchId);

  /**
   * Statistic ID From API Match Top Stats List
   * 1 -> Goals
   * 25 -> Yellow Card
   * 28 -> Red Card
   * 250 -> Passes Completed
   * 18 -> Save
   * */

  const dataMatchDetail = dataMatchDetailRaw?.data?.data;
  const dataMatchGoal = dataMatchDetail?.goals;
  const dataCards = dataMatchDetail?.cards;

  const getSafeValue = (value: number) => {
    if (typeof value !== "number") return 0;

    return value;
  };

  const homeMatchDetail = {
    goals: getSafeValue(
      dataMatchDetail?.goals?.filter((data) => data?.team_type === "home")?.length || 0,
    ),
    fouls: getSafeValue(dataMatchDetail?.school_1_fouls),
    yellowCard: dataCards?.filter(
      (data) => data?.card_type === "yellow" && data?.team_type === "home",
    )?.length,
    redCard: dataCards?.filter((data) => data?.card_type === "red" && data?.team_type === "home")
      ?.length,
    penaltyGoals: getSafeValue(dataMatchDetail?.home_penalty_shootout_win) || 0,
  };

  const awayMatchDetail = {
    goals: getSafeValue(
      dataMatchDetail?.goals?.filter((data) => data?.team_type === "away")?.length || 0,
    ),
    fouls: getSafeValue(dataMatchDetail?.school_2_fouls),
    yellowCard: dataCards?.filter(
      (data) => data?.card_type === "yellow" && data?.team_type === "away",
    )?.length,
    redCard: dataCards?.filter((data) => data?.card_type === "red" && data?.team_type === "away")
      ?.length,
    penaltyGoals: getSafeValue(dataMatchDetail?.away_penalty_shootout_win) || 0,
  };

  const dataCardItem = {
    ...data,
    match_status: data?.match_status,
    home_score: dataMatchDetail?.home_score || 0,
    away_score: dataMatchDetail?.away_score || 0,
    home_penalty_score: dataMatchDetail?.home_penalty_score || undefined,
    away_penalty_score: dataMatchDetail?.away_penalty_score || undefined,
  };

  if (isFetching && !isRefetching) return <Loading />;

  return (
    <React.Fragment>
      <div
        style={{
          background: `url(${func.getStaticImg(
            "/bg/bg-swoosh-blur.png",
          )}) #1F2D3D 100% / cover no-repeat`,
        }}
        className="absolute top-[64px] bottom-0 right-0 left-0"
      />
      <div className="z-10 relative flex flex-col mx-auto gap-y-[12px max-w-[807px]">
        <div className="max-w-[756px] w-[100%] mx-auto ">
          <CardItem
            item={dataCardItem as any}
            bgColor={isMobileView ? "#1f2d3d" : ""}
            isForceHideStatisticButton
          />
          {!isMobileView && <div className="mb-[16px]" />}

          {isMobileView ? (
            <div className="px-[20px]">
              <ScoreBoard data={dataMatchGoal} cards={dataCards} />
            </div>
          ) : (
            <ScoreBoard data={dataMatchGoal} cards={dataCards} />
          )}
        </div>

        {!isMobileView && <div className="mb-[24px]" />}

        <div className="mx-[20px] mt-[16px] max-w-[806px]">
          {/* {renderTabBar()} */}

          <Show when={activeTab === 0}>
            <MatchDetail home={homeMatchDetail} away={awayMatchDetail} />
          </Show>
          {/* <Show when={activeTab === 1}>
            <TopStats
              topScorer={dataGoals}
              redCards={dataRedCards}
              yellowCards={dataYellowCards}
              saves={dataSaves}
              successfulPasses={dataPassesCompleted}
            />
          </Show> */}
        </div>
      </div>
    </React.Fragment>
  );
};

export default StatisticDetail;
